module.exports = __webpack_public_path__ + "static/img/ttDriver.71ac9639.png";